import { AppProviders } from './providers/AppProviders';
import { AppRouter } from './router';
import { AuthBootstrap } from '@/features/auth';

export function App() {
  return (
    <AppProviders>
      <AuthBootstrap>
        <AppRouter />
      </AuthBootstrap>
    </AppProviders>
  );
}

export default App;
